<template>
  <li class="nav-item" :class="['layer'+layer,show?'show':'']" @tap.stop="navClick(data)">
    <div class="nav-item-text">{{data.name}}<img class="m-l-5" v-show="data.children"
                                                 src="../../assets/img/header/arrow.png"
                                                 :class="{'rotate180':isUnfold}"></div>
    <ul v-if="data.children" class="nav-item-ul">
      <nav-item-mobile ref="navItem" v-for="(item, mobileIndex) in data.children" :data="item" :index="mobileIndex"
                       :key="mobileIndex" :layer="layer+1" :show="isUnfold"
                       :TypeLists="TypeLists" :CaseLists="CaseLists"></nav-item-mobile>
    </ul>
  </li>
</template>

<script>
  export default {
    name: "NavItemMobile",
    props: {
      index: Number,
      data: Object,
      layer: Number,
      show: Boolean,
      TypeLists: {
        type: Array,
        default: null,
      },
      CaseLists: {
        type: Array,
        default: null,
      }
    },
    data() {
      return {};
    },
    computed: {
      isUnfold() {
        return this.$store.state.navState[this.layer] === this.index;  //展开
      },
    },
    methods: {
      navClick(route) {
        const currentIndex = this.$store.state.navState[this.layer];   //当前层级
        if (currentIndex == this.index) {
          this.$store.commit('updateNavState', {index: this.layer, value: -1});   //使其折叠
        } else {
          this.$store.commit('updateNavState', {index: this.layer, value: this.index});  //使其展开
        }
        
        console.log("route对象",route);
        console.log("route.path",route.path);
        console.log("this.TypeLists", this.TypeLists);
        console.log("route.name", route.name);

        // 处理coreProduct路由参数
        if (this.TypeLists && route.path === "/coreProduct") {
          const matchingType = this.TypeLists.find((item) => item.coreProductTypeName === route.name);
          if (matchingType) {
            // 如果找到匹配项，将TypeLists下的coreProductTypeId赋值给导航中的id
            route.id = matchingType.coreProductTypeId;
            
            // 带参数跳转到coreProduct路由
            this.$store.commit('foldNav');
            this.$router.push({
              path: route.path,
              query: {
                coreProductTypeName: matchingType.coreProductTypeName,
                coreProductTypeId: matchingType.coreProductTypeId
              }
            });
            return;
          }
        }

        // 处理CaseLists路由参数
        if (this.CaseLists && route.path === "/v2customerCase") {
          const matchingCase = this.CaseLists.find((item) => item.productServiceTypeName === route.name);
          if (matchingCase) {
            // 如果找到匹配项，将CaseLists下的productServiceTypeId赋值给导航中的id
            route.id = matchingCase.productServiceTypeId;
            
            // 带参数跳转到v2customerCase路由
            this.$store.commit('foldNav');
            this.$router.push({
              path: route.path,
              query: {
                productServiceTypeName: matchingCase.productServiceTypeName,
                productServiceTypeId: matchingCase.productServiceTypeId
              }
            });
            return;
          }
        }

        // 原有逻辑
        if (route.path) {
          if (this.$router.currentRoute.path !== route.path) {
            this.$store.commit('foldNav');
            if (route.path.indexOf("http") != -1) {
              window.open(route.path, "_blank");
            }
            else {
              this.$router.push({path: route.path});
            }
          }
        }
      },
    }
  }

</script>

<style scoped>
  .show > .nav-item-text {
    max-height: 40px;
    transition: max-height .3s ease;
  }

  .nav-item-text {
    max-height: 0;
    height: auto;
    transition: max-height .3s ease;
  }

  .pc-box .nav-item-container .layer1 {
    line-height: 30px;
    font-size: 15px;
  }

  .pc-box .nav-item-container .layer1:hover > .nav-item-text {
    color: #333;
  }

  .pc-box .nav-item-container .layer2 {
    line-height: 30px;
    font-size: 14px;
  }

  .pc-box .nav-item-container .layer2:hover {
    color: #eb580e;
  }

  .nav-item {
    width: 100%;
  }

  .nav-item ul {
    overflow: hidden;
  }

  .nav-item ul li {
    max-height: 0;
    transition: max-height .3s ease;
  }

  .nav-item:hover ul li {
    max-height: 40px;
    transition: max-height .3s ease;
  }

  .mobile-box .nav-item-container .layer1 {
    line-height: 40px;
    font-size: 15px;
    text-indent: 15px;
    opacity: .8;
  }

  .mobile-box .nav-item-container .layer1:hover > .nav-item-text {
    color: #fff;
  }

  .mobile-box .nav-item-container .layer2 .nav-item-text {
    font-size: 14px;
    text-indent: 30px;
  }

  .mobile-box .nav-item .nav-item-text {
    position: relative;
  }

  .mobile-box .nav-item .nav-item-text > img {
    position: absolute;
    right: 0px;
    top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavMenuMobile/NavItemMobile.vue